// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { injectCss } from "@insite/mobius/utilities";
import breakpoints from "@werner/XDL/PreStyle/breakpoints";
import React, { ReactNode } from "react";
import styled from "styled-components";

interface PictureProps {
    smallPath?: string;
    mediumPath?: string;
    children?: ReactNode;
}

const LazyPictureStyle = styled.picture<any>`
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    height: 100%;
    img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
    }

    ${injectCss}
`;

/**
 * Xng Picture Component
 */
const Picture: React.FC<PictureProps> = (props: any) => {
    const { children, smallPath, mediumPath } = props;
    return (
        <LazyPictureStyle {...props}>
            <source media={`(max-width: ${breakpoints.values[3]}px)`} data-srcset={smallPath} />
            <source media={`(max-width: ${breakpoints.values[2]}px)`} data-srcset={mediumPath} />
            {children}
        </LazyPictureStyle>
    );
};

/** @component */
export default Picture;
